module.exports = __webpack_public_path__ + "img/drag-icon.13f3ca7b.svg";